export default "__VITE_ASSET__De6TR5aQ__"